import Clock from "./assets/clock.svg";
import PhoneCall from "./assets/phone-call.svg";
import Globe from "./assets/globe.svg";
import glueupLogo from "./assets/glueup.png";
import sarahImage from "./assets/sarah.jpg";
import calendlyLogo from "./assets/calendly.svg";
import googleLogo from "./assets/googlel.svg";


import "./App.css";

import { Link, NavLink } from "react-router-dom";
import CurrentTime from "./CurrenTime";

export default function CalendlySchedule() {
  // 2. Immediately call your backend

  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const openLoginPopup = async () => {
    const width = 600;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    try {
      const response = await fetch(`${API_URL}/api/new-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to login");
      }

      const data = await response.json();
      console.log("Session ID:", data.session_id);
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div className="calendy-div">
      <div className="calendy-grid">
        <div className="left-side">
          <div>
            <div style={{ textAlign: "center" }}>
              <img src={glueupLogo} alt="GlueUp" className="selby-logo" />
              <h3 style={{ marginTop: "18px", marginBottom: "6px" }}>Sarah McConnell</h3>
              <h2>Meet Sarah</h2>
              <img
                src={sarahImage}
                alt="Sarah McConnell"
                style={{
                  width: "96px",
                  height: "96px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginTop: "16px",
                  border: "3px solid #fff",
                  boxShadow: "0 6px 18px rgba(0, 0, 0, 0.16)",
                }}
              />
            </div>
            <div className="calendy-div-icons">
              <div className="calendy-icons">
                <img src={Clock} alt="clock" />
                <span>30 min</span>
              </div>

              <div className="calendy-icons" style={{ gap: "15px" }}>
                <img src={PhoneCall} alt="phone call" />
                <span>Phone Call</span>
              </div>

              <div className="footer-links">
                <a>Cookie settings</a>
                <a>Report abuse</a>
              </div>
            </div>
          </div>
        </div>

        <div className="right-side">
          <Link className="VJL48qbQzWENTFAh1Knk e9TS9yoMqqIN2PqBo1QG _i6SG2jlTfccH2ZZblil">
            <div
              data-id="branding"
              className="jWSwi_R_Xl7kPjUhuQoo _igrKj_5lj_5nWQu8DPw"
            >
              <div className="V7YfvNqWv0XKYKys7N7K __d5yUqDgBEjoX7J2dql">
                powered by
              </div>
              <div className="HvybhIo63ZbBJxHh7Ann RK3ps09FjZwzHTaYDakl">
                Calendly
              </div>
            </div>
          </Link>

          <div>
            <div className="calendy-logo">
              <img src={calendlyLogo} alt="Calendly Logo" />
            </div>

            <h2>Schedule your call with us!</h2>

            <h3></h3>

            <div className="fb-text">
              <p className="fb-paragraphg">
                <span>
                  The easiest way for you to sign up is with Google.
                </span>{" "}
                <span>This will automatically connect your calendar</span>{" "}
                <span>so you can start using Calendly right away.</span>
              </p>
              {/* <button onClick={openLoginPopup} className="fb-btn"> */}
              <NavLink to="/login" className="google-btn" onClick={openLoginPopup}>
                <img src={googleLogo} alt="Google" />
                Continue with Google
              </NavLink>
            </div>
          </div>

          <div className="time">
            <h4>Time zone</h4>
            <div className="timezone">
              <img src={Globe} alt="globe" />
              <CurrentTime />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}